export default defineAppConfig({
  trackingLayer: {},
});

declare module "@nuxt/schema" {
  interface AppConfigInput {
    trackingLayer?: {};
  }
}
